// Only the seven missing targets. The publisher's SingleSound.soundMap
// identifies these as standalone sounds, separately from example word audio.
// Pinned source version prevents upstream changes from silently altering lessons.
export const aePronunciationSource = {
  publisher: 'Jonathan Sande / aePronunciation',
  repository: 'https://github.com/suragch/aePronunciation-iOS',
  revision: '2d6692582cf2796b92ecd4c15bdbac19b07420ea',
  license: 'Unlicense',
  licenseUrl: 'https://raw.githubusercontent.com/suragch/aePronunciation-iOS/2d6692582cf2796b92ecd4c15bdbac19b07420ea/LICENSE',
  termsUrl: 'https://www.aepronunciation.com/',
  speaker: 'Native American English speaker; publisher Jonathan Sande (developer-described recordings)',
  nativeSpeakerEvidence: 'https://apps.apple.com/us/app/ae-pronunciation/id1049726030',
  accentEvidence: 'https://www.aepronunciation.com/lessons/lesson-3/',
  mappingEvidence: 'https://raw.githubusercontent.com/suragch/aePronunciation-iOS/2d6692582cf2796b92ecd4c15bdbac19b07420ea/aePronunciation/SingleSound.swift',
  accentQa: 'American English source; publisher describes cot–caught merger. Independent child-phonics and cross-speaker QA pending.',
} as const

const rows = [
  ['th_voiced', 'ð', 'single_th_voiced', 'th', 'there'],
  ['ng', 'ŋ', 'single_ng', 'ng', 'ringing'],
  ['short_oo', 'ʊ', 'single_u_short', 'oo', 'put'],
  ['r_schwa', 'ɚ', 'single_er_unstressed', 'er', 'mother'],
  ['r_air', 'ɛr', 'single_er', 'air', 'aired'],
  ['r_ear', 'ɪr', 'single_ir', 'ear', 'ear'],
  ['schwa', 'ə', 'single_shwua', 'a', 'above'],
] as const

export const aePronunciationReferenceCatalog = rows.map(([name, sourceIpa, file, spelling, example]) => ({
  id: `aepronunciation_${name}`,
  phonemeId: `phoneme_${name}`,
  sourceIpa,
  sourceFile: `${file}.mp3`,
  sourceUrl: `https://raw.githubusercontent.com/suragch/aePronunciation-iOS/${aePronunciationSource.revision}/aePronunciation/raw/${file}.mp3`,
  sourcePage: `https://github.com/suragch/aePronunciation-iOS/blob/${aePronunciationSource.revision}/aePronunciation/SingleSound.swift`,
  sourceSpelling: spelling,
  sourceExample: example,
  sourceKind: 'standalone_phoneme' as const,
  publisher: aePronunciationSource.publisher,
  speaker: aePronunciationSource.speaker,
  license: aePronunciationSource.license,
  licenseUrl: aePronunciationSource.licenseUrl,
  sourceRevision: aePronunciationSource.revision,
  nativeSpeakerEvidence: aePronunciationSource.nativeSpeakerEvidence,
  accentEvidence: aePronunciationSource.accentEvidence,
}))
